export default __webpack_public_path__ + "static/media/vision-section-04-1.0cbfc0a6.png";